export default {
    client: {
        state: {
            monitorRefreshTrigger: 0
        },
        actions: {
            trigger({state}) {
                state.monitorRefreshTrigger++;
            }
        }
    }
}